<template>
    <div>
        <div class="tabs-component" :class="viewClass">

            <div class="tab-header view-header-buttons" v-if="$slots['nav-item-center']">
                <slot name="nav-item-center"/>
            </div>

            <ul role="tablist" class="tab-header nav nav-tabs nav-tabs-2 float-sm-left">
                <li
                        v-for="(tab, i) in tabs"
                        :key="i"
                        :class="{ 'is-active': tab.isActive, 'is-disabled': tab.isDisabled }"
                        class="tabs-component-tab nav-item"
                        role="presentation"
                        v-show="tab.isVisible"
                >
                    <a v-html="tab.header"
                       :aria-controls="tab.hash"
                       :aria-selected="tab.isActive"
                       @click="selectTab(tab.hash, $event)"
                       :class="{ 'active': tab.isActive, 'disabled': tab.isDisabled }"
                       :href="tab.hash"
                       class="tabs-component-tab-a  nav-link"
                       role="tab"
                    ></a>
                </li>
            </ul>
            <div class="tab-header rs-btn-group float-sm-right mt-1-sm">
                <slot name="nav-item-right"/>
            </div>
        </div>
        <div :style="cssProps">
            <slot/>
        </div>
    </div>
</template>

<script>
    import expiringStorage from '../expiringStorage';

    export default {
        props: {
            viewClass:{
              default: '',
            },
            cacheLifetime: {
                default: 5,
            },
            isNeedSaveTabs: {
              type: Boolean,
              default: true,
            },
            options: {
                type: Object,
                required: false,
                default: () => ({
                    useUrlFragment: true,
                    defaultTabHash: null,
                }),
            },
            topGap:{
                type:Boolean,
                default: true,
            }
        },

        data: () => ({
            tabs: [],
            activeTabHash: '',
            activeTabIndex: 0,
            lastActiveTabHash: '',
        }),

        computed: {
            storageKey() {
                return `vue-tabs-component.cache.${window.location.host}${window.location.pathname}`;
            },
            cssProps() { return {
                            'border': !this.topGap && 'none'
                        }
            }
        },

        created() {
            this.tabs = this.$children;
            console.log("length",this.tabs);
        },

        mounted() {
            window.addEventListener('hashchange', () => this.selectTab(window.location.hash));

            if (this.findTab(window.location.hash)) {
                this.selectTab(window.location.hash);
                return;
            }

            if (this.isNeedSaveTabs) {
              const previousSelectedTabHash = expiringStorage.get(this.storageKey);

              if (this.findTab(previousSelectedTabHash)) {
                this.selectTab(previousSelectedTabHash);
                return;
              }
            }

            console.log('this.options.defaultTabHash',this.options.defaultTabHash)
            if(this.options.defaultTabHash !== null && this.findTab("#" + this.options.defaultTabHash)) {
                console.log('set defaultTabHash', this.options.defaultTabHash)
                this.selectTab("#" + this.options.defaultTabHash);
                return;
            }

            if (this.tabs.length) {
                let hash = '';
                if (this.tabs[0].hash) {
                    hash = this.tabs[0].hash;
                }else if(this.tabs[1].hash){
                    hash = this.tabs[1].hash;
                }
                this.selectTab(hash);
            }
        },

        methods: {
            findTab(hash) {
                return this.tabs.find(tab => tab.hash === hash);
            },

            selectTab(selectedTabHash, event) {
                // See if we should store the hash in the url fragment.
                if (event && !this.options.useUrlFragment) {
                    event.preventDefault();
                }

                const selectedTab = this.findTab(selectedTabHash);

                if (!selectedTab) {
                    return;
                }

                if (selectedTab.isDisabled) {
                    event.preventDefault();
                    return;
                }

                if (this.lastActiveTabHash === selectedTab.hash) {
                    this.$emit('clicked', { tab: selectedTab });
                    return;
                }

                this.tabs.forEach(tab => {
                    tab.isActive = (tab.hash === selectedTab.hash);
                });

                this.$emit('changed', { tab: selectedTab });

                this.activeTabHash = selectedTab.hash;
                this.activeTabIndex = this.getTabIndex(selectedTabHash);

                this.lastActiveTabHash = this.activeTabHash = selectedTab.hash;

                if (this.isNeedSaveTabs) {
                  expiringStorage.set(this.storageKey, selectedTab.hash, this.cacheLifetime);
                }
            },

            setTabVisible(hash, visible) {
                const tab = this.findTab(hash);

                if (! tab) {
                    return;
                }

                tab.isVisible = visible;

                if (tab.isActive) {
                    // If tab is active, set a different one as active.
                    tab.isActive = visible;

                    this.tabs.every((tab, index, array) => {
                        if (tab.isVisible) {
                            tab.isActive = true;

                            return false;
                        }

                        return true;
                    });
                }
            },

            getTabIndex(hash){
                const tab = this.findTab(hash);

                return this.tabs.indexOf(tab);
            },

            getTabHash(index){
                const tab = this.tabs.find(tab => this.tabs.indexOf(tab) === index);

                if (!tab) {
                    return;
                }

                return tab.hash;
            },

            getActiveTab(){
                return this.findTab(this.activeTabHash);
            },

            getActiveTabIndex() {
                return this.getTabIndex(this.activeTabHash);
            },
        },
    };
</script>
<style scoped>

</style>
